import { render } from "./SkyInputRadioSwitch.vue?vue&type=template&id=296fe9c2&scoped=true"
import script from "./SkyInputRadioSwitch.vue?vue&type=script&lang=js"
export * from "./SkyInputRadioSwitch.vue?vue&type=script&lang=js"

import "./SkyInputRadioSwitch.vue?vue&type=style&index=0&id=296fe9c2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-296fe9c2"]])

export default __exports__